window.fit = window.fit || {};

(function($) {

  fit.Header = function(root) {
    this.root = root;
    this._attach();
  };

  fit.Header.prototype = {
    _attach : function() {
      this.root.find('.js-header-menu-toggle').on('click', this._toggle.bind(this));
    },
    _toggle : function() {

      if (this.root.hasClass('is-open')){
        this.root.removeClass('is-open');
        $('.mobile-menu-overlay').fadeOut(200);
        return
      } else {
        this.root.addClass('is-open');
      }

      if (!this.overlay) {
        var overlay = this.overlay = $('<div class="mobile-menu-overlay">');
        this.root.before(overlay);
      }

      $('.mobile-menu-overlay').fadeIn(200);

    }
  };

  new fit.Header($('.js-header'))

})(jQuery);
